import SeamlyBaseError from './seamly-base-error'

export default class SeamlyOfflineError extends SeamlyBaseError {
  constructor(originalError, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlyOfflineError'
    this.langKey = 'errors.seamlyOffline'
  }
}
